import common from '../../../common';
import MagicPencil from './MagicPencil';
import ColourPencil from './ColourPencil';

const _draw = Symbol('_draw');
const _stopAudio = Symbol('_stopAudio');
const _onColour_Changed = Symbol('_onColour_Changed');

export default class Pencil{
	constructor() {
		// Attributes.
		this._drawLayer = null;
		this._magicPencil = null;
		this._colourPencil = null;
		this._paletteItem = null;
		this._curPencil = null;
		this._audio = null;
	}

	init(drawLayer) {
		this._drawLayer = drawLayer;

		// Magic pencil.
		this._magicPencil = new MagicPencil();
		this._magicPencil.init(drawLayer);

		// Colour pencil.
		this._colourPencil = new ColourPencil();
		this._colourPencil.init(drawLayer);

		// Set initial pencil.
		this._curPencil = this._colourPencil;
		this._curPencil.colour = common.gameConfig.palettePanel.pages[0][0];
		this._paletteItem = this._curPencil.colour;

		// Signals.
		common.game.scene.palettePanel.signals.onColourChanged.add(this[_onColour_Changed], this);
	}

	onDrawBegan(point) {
		this._curPencil.onDrawBegan(point);
		this[_draw](point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
	}

	onDrawMoved(from, to) {
		// Sfx.
		if (this._audio == null)
			this._audio = P3.audio.playSound('sfx_tool_pencil_use_loop_00', {'loop': true});
		P3.utils.delay(0.25, ()=>{
			this[_stopAudio]();
		}, null, this);

		this._curPencil.onDrawMoved(from, to);
		this[_draw](from, to);
	}

	onDrawEnded(){
		// Sfx.
		if (this._audio != null)
			this[_stopAudio]();

		// TEST: DYN_OUT:
		common.game.canvas.drawLayer.dynOutlineData = common.game.canvas.drawLayer._dynOutlineContext.getImageData(
			0,
			0,
			common.game.canvas.WIDTH,
			common.game.canvas.HEIGHT
		);
	}

	[_draw](from, to) {
		// TEST: DYN_OUT:
		common.game.canvas.drawLayer._dynOutlineContext.beginPath();
		common.game.canvas.drawLayer._dynOutlineContext.strokeStyle = 'black';
		common.game.canvas.drawLayer._dynOutlineContext.lineWidth = this._curPencil.LINE_THICKNESS;
		common.game.canvas.drawLayer._dynOutlineContext.lineJoin = 'round';
		common.game.canvas.drawLayer._dynOutlineContext.moveTo(from.x, from.y);
		common.game.canvas.drawLayer._dynOutlineContext.lineTo(to.x, to.y);
		common.game.canvas.drawLayer._dynOutlineContext.closePath();
		common.game.canvas.drawLayer._dynOutlineContext.stroke();
	}

	[_stopAudio](){
		this._audio && this._audio.stop();
		this._audio = null;
	}

	[_onColour_Changed](selection) {
		if (selection.indexOf('#') === 0) {
			this._curPencil = this._colourPencil;
			this._colourPencil.colour = selection;
		}
		else {
			this._curPencil = this._magicPencil;
			this._magicPencil.textureId = selection;
		}

		this._paletteItem = selection;
	}

	get paletteItem(){
		return this._paletteItem;
	}
}